import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/material/styles";

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)({
  marginLeft: '8px !important',
})
